package com.anjuros.website.templates.template1.modules

import com.anjuros.website.templates.template1.util.ResKey

enum class Template1ProductFeature(
    val icon: String,
    val title: ResKey,
    val text: ResKey
) {

    FEATURE1(
        icon = "template1_about1.png",
        title = ResKey.TEMPLATE1_HERO_FEATURE1_TITLE,
        text = ResKey.TEMPLATE1_HERO_FEATURE1_TEXT
    ),

    FEATURE2(
        icon = "template1_about2.png",
        title = ResKey.TEMPLATE1_HERO_FEATURE2_TITLE,
        text = ResKey.TEMPLATE1_HERO_FEATURE2_TEXT
    ),

    FEATURE3(
        icon = "template1_about3.png",
        title = ResKey.TEMPLATE1_HERO_FEATURE3_TITLE,
        text = ResKey.TEMPLATE1_HERO_FEATURE3_TEXT
    ),

    FEATURE4(
        icon = "template1_about4.png",
        title = ResKey.TEMPLATE1_HERO_FEATURE4_TITLE,
        text = ResKey.TEMPLATE1_HERO_FEATURE4_TEXT
    )
}